const getHtmlFromRedactorField = (field) => {
  if (!field) {
    return null
  }
  return { __html: `<div>${ field }</div>` }
}

export default getHtmlFromRedactorField
